import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { SelectV2, SelectV2Props } from "./select-v2";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";

interface ControlledSelectV2Props<T extends FieldValues>
  extends Omit<SelectV2Props, "value" | "onChange" | "error" | "id"> {
  name: Path<T>;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>>;
  setValue?: (value: string) => void;
}

export const ControlledSelectV2 = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  setValue,
  ...selectProps
}: ControlledSelectV2Props<T>) => {
  const translateMessage = useTranslateMessage();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <SelectV2
          {...selectProps}
          value={field.value?.toString()}
          onChange={(value) => {
            setValue ? setValue(value) : field.onChange(value);
          }}
          error={translateMessage(error?.message)}
          id={name}
        />
      )}
    />
  );
};
